import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const setFavicon = () => {
  const iconHref = "/assets/logo-mi-web-vacacional-icon.png";
  const existingIcon = document.querySelector('link[rel="icon"]');

  if (existingIcon) {
    existingIcon.setAttribute("href", iconHref);
  } else {
    const icon = document.createElement("link");
    icon.rel = "icon";
    icon.type = "image/png";
    icon.href = iconHref;
    document.head.appendChild(icon);
  }
};

setFavicon();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
